import { render, staticRenderFns } from "./AssetImageOriginalInfo.vue?vue&type=template&id=747539ea&lang=pug"
import script from "./AssetImageOriginalInfo.vue?vue&type=script&lang=js"
export * from "./AssetImageOriginalInfo.vue?vue&type=script&lang=js"
import style0 from "./AssetImageOriginalInfo.vue?vue&type=style&index=0&id=747539ea&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports